module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-9d4d17c8b3ed406ce7f7815d21b2c5fa.webp";